import React, { } from "react";
import { IoEyeSharp } from "react-icons/io5";
import BrandComponents from "../Brand/BrandComponents";


function StaffTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "First Name", field: "firstname" },
    { label: "Last Name", field: "lastname" },
    { label: "Email", field: "email" },
    { label: "Mobile No.", field: "mobileno" },


  ];
  const sumofkeys = [{ first: "staffname" }];

  return (
    <div>
      <BrandComponents
        header={header}
        tableTitle={"STAFF-LIST"}
        apiField={"staff"}
        addButton={"+ ADD"}
        createRoute={"/staffCreate"}
        updateRoute={"/staffView"}
        viewRoute={"/staffView"}
      />
    </div>
  );
}

export default StaffTable;
